export default {
  deriveRegionFromAddress(address) {
    if (!address) return "";
    const parts = address.trim().split(/\s+/);
    if (parts.length < 2) return parts[0] || "";
    return `${parts[0]} ${parts[1]}`;
  },
  searchAddress() {
    // eslint-disable-next-line no-undef
    if (typeof daum === "undefined" || !daum.Postcode) {
      this.$alert(
        "주소 검색을 불러오지 못했습니다. 잠시 후 다시 시도해주세요."
      );
      return;
    }
    this.addressModalOpen = true;
    this.$nextTick(() => {
      const container = this.$refs.postcodeContainer;
      if (!container) return;
      container.innerHTML = "";
      // eslint-disable-next-line no-undef
      new daum.Postcode({
        oncomplete: (data) => {
          this.form.address = data.address;
          this.form.detailAddress = "";
          const sido = data.sido || "";
          const sigungu = data.sigungu || "";
          this.form.region =
            `${sido} ${sigungu}`.trim() ||
            this.deriveRegionFromAddress(data.address);
          this.closeAddressModal();
          this.$nextTick(() => {
            if (this.$refs.detailAddressInput) {
              this.$refs.detailAddressInput.focus();
            }
          });
        },
        width: "100%",
        height: "100%",
      }).embed(container);
    });
  },
  closeAddressModal() {
    this.addressModalOpen = false;
    const container = this.$refs.postcodeContainer;
    if (container) container.innerHTML = "";
  },
};
